"use client"

import { Container, Stack, Typography } from "@mui/material"
import { Link } from "@tc/ui-dfe/components"

export function OcaSuspendedPage() {
  return (
    <Stack sx={{ width: "100%" }} alignItems="center" justifyContent="center">
      <Container fixed sx={{ maxWidth: "600px", textAlign: "center" }}>
        <Stack
          spacing={3}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 4 }}
        >
          <Typography
            variant="h5"
            data-testid="suspended-heading"
            component="strong"
            color="error"
          >
            Access Suspended
          </Typography>
          <Typography variant="body1" data-testid="suspended-message">
            Your access has been suspended, please contact{" "}
            <Link
              href="mailto:tradecertification@mpi.govt.nz"
              custom
              aria-label="Email Trade Certification support"
            >
              tradecertification@mpi.govt.nz
            </Link>
          </Typography>
        </Stack>
      </Container>
    </Stack>
  )
}
